import App from '@app/App';
import { reloadOnceForStaleChunk } from '@utils/chunkReload';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';


// Vite fires this when a <link rel="modulepreload"> for a JS chunk 404s.
// This is a separate failure path from the dynamic import() errors handled
// by RouteErrorBoundary (that one goes through React Router's error
// handling; this one doesn't touch React at all), so it needs its own
// listener.
window.addEventListener('vite:preloadError', reloadOnceForStaleChunk);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
